import React, {useMemo} from 'react';
import _ from 'lodash';
import {IBreadCrumb} from '../../interface';
import style from './Breadcrumb.module.scss';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { SBreadcrumbs } from '@avalara/skylab-sdk/react';
import { BreadcrumbItem } from '@avalara/skylab-sdk';

interface Props {
  items: IBreadCrumb[];
  className?: string;
}

/* Breadcrumb of company & property & owner setup page */
function Breadcrumb(props: Props) {
  const navigate = useNavigate();
  const navtems: BreadcrumbItem[] = useMemo(
    () =>
      _.map(props.items, (item, i) => ({
        label: item.value,
        url: item.href,
        dataRef: i.toString(),
        emitNavEvent: true,
      })),
    [props.items],
  );

  return (
    <div className={classNames(style['breadcrumb'], props.className)}>
      <SBreadcrumbs
        navItems={navtems}
        onS-navigate={(e: CustomEvent<BreadcrumbItem>) => navigate(e.detail.url as string)}
      ></SBreadcrumbs>
    </div>
  );
}

export default Breadcrumb;
